import Drawer from "react-modern-drawer";
import {useEffect, useState} from "react";
import {Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {Btn, H4} from "../../AbstractElements";
import {handlerSetFormString} from "../../Utils/forms";
import axios from "axios";
import SweetAlert from "sweetalert2";
import {CreateFilterEncoding, CreatePaginationEncoding} from "../../Utils/Base64/request";
import {API_USER} from "../../api/service";
import {RoleSelect} from "../Select/RoleSelect";

export const PenggunaFormDrawer = ({id, open, onClose, direction = "right", className}) => {
    const initialData = {
        id: 0,
        full_name: "",
        login_username: "",
        login_password: "",
        role: 2
    }
    const [data, setData] = useState(initialData)

    useEffect(() => {
        if (id !== 0) {
            axios.get(API_USER + "/?pagination=" + CreatePaginationEncoding(1, 0) + "&filter=" + CreateFilterEncoding({
                id: id
            })).then(r => {
                if (r.status === 200) {
                    return r.data["data"]
                }
            }).then(json => {
                if (json.data) {
                    json.data.length > 0 && setData(json.data[0])
                }
            })
        } else {
            setData(initialData)
        }
    }, [id])

    const handlerSubmit = (e) => {
        e.preventDefault()
        if (id === 0) {
            axios.post(API_USER + "/", {...data}).then(r => {
                if (r.status === 204) {
                    SweetAlert.fire({
                        title: 'Success!',
                        text: 'Data Saving Completed!',
                        icon: 'success'
                    }).then(() => {
                        onClose()
                    })
                } else {
                    throw r
                }
            }).catch((err) => {
                SweetAlert.fire({
                    title: 'Failed!',
                    text: 'Data Saving Failed!',
                    icon: 'error'
                })
            })
        } else {
            axios.put(API_USER + "/", {...data, id: id}, {withCredentials: true}).then(r => {
                if (r.status === 204) {
                    SweetAlert.fire({
                        title: 'Success!',
                        text: 'Data Saving Completed!',
                        icon: 'success'
                    }).then(() => {
                        onClose()
                    })
                } else {
                    throw r
                }
            }).catch((err) => {
                SweetAlert.fire({
                    title: 'Failed!',
                    text: 'Data Saving Failed!',
                    icon: 'error'
                })
            })
        }

    }

    return (
        <Drawer
            open={open}
            onClose={onClose}
            direction={direction}
            className={'creation-drawer ' + className}
        >
            <div className="m-b-30">
                <H4>{id !== 0 ? "Edit" : "Buat"} Pengguna</H4>
                <hr/>
            </div>
            <Form className="form theme-form" onSubmit={handlerSubmit}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Nama Lengkap</Label>
                            <Input required name="full_name" value={data.full_name}
                                   onChange={(e) => handlerSetFormString(e, data, setData)}
                                   className="form-control btn-square" type="text"
                                   placeholder="Type Something"/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Username</Label>
                            <Input required name="login_username" value={data.login_username}
                                   onChange={(e) => handlerSetFormString(e, data, setData)}
                                   className="form-control btn-square" type="text"
                                   placeholder="Type Something"/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Password</Label>
                            <Input required name="login_password" value={data.login_password}
                                   onChange={(e) => handlerSetFormString(e, data, setData)}
                                   className="form-control btn-square" type="password"
                                   placeholder="Type Something"/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Role</Label>
                            <RoleSelect selected={data.role} onChange={(e) => {
                                setData({
                                    ...data,
                                    role: e.value,
                                })
                            }}/>
                        </FormGroup>

                    </Col>
                </Row>
                <Btn attrBtn={{
                    color: 'primary',
                    className: 'm-r-15',
                    type: 'submit',
                }}
                >Submit</Btn>
                <Btn attrBtn={{color: 'light', onClick: () => onClose()}}>Cancel</Btn>
            </Form>
        </Drawer>
    )
}